import { render } from "./DnsZoneStats.vue?vue&type=template&id=4e64a5be&scoped=true&lang=pug"
import script from "./DnsZoneStats.vue?vue&type=script&setup=true&lang=js"
export * from "./DnsZoneStats.vue?vue&type=script&setup=true&lang=js"

import "./DnsZoneStats.vue?vue&type=style&index=0&id=4e64a5be&scoped=true&lang=sass"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e64a5be"]])

export default __exports__